import { useEffect, useState } from 'react';
import { logger } from '@/lib/logger';

export const useFullscreen = (isActive: boolean) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (!isActive) return;

    const enterFullscreen = async () => {
      try {
        // Tentar entrar em fullscreen
        if (document.documentElement.requestFullscreen) {
          await document.documentElement.requestFullscreen();
          setIsFullscreen(true);
          logger.info('Entered fullscreen mode');
        }

        // Ocultar barra de endereço no mobile (fallback)
        window.scrollTo(0, 1);
      } catch (err) {
        logger.warn('Fullscreen failed, using fallback', err);
        // Mesmo se falhar, continuar com scroll
        window.scrollTo(0, 1);
      }
    };

    const exitFullscreen = async () => {
      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
          setIsFullscreen(false);
          logger.info('Exited fullscreen mode');
        }
      } catch (err) {
        logger.warn('Exit fullscreen failed', err);
      }
    };

    enterFullscreen();

    // Cleanup ao desmontar
    return () => {
      exitFullscreen();
    };
  }, [isActive]);

  return { isFullscreen };
};
